import { Events } from '../config/analyticsEvents';

const userProps = {};
let sessionId = null;

function getSessionId() {
  if (sessionId) return sessionId;
  try {
    sessionId = sessionStorage.getItem('lf_session_id');
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
      sessionStorage.setItem('lf_session_id', sessionId);
    }
  } catch {
    sessionId = String(Date.now());
  }
  return sessionId;
}

function buildPayload(event, params = {}) {
  return {
    type: 'analytics',
    event,
    params,
    timestamp: Date.now(),
    sessionId: getSessionId(),
    user: { ...userProps }
  };
}

function sendToNative(payload) {
  if (typeof window === 'undefined') return;

  const json = JSON.stringify(payload);

  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(json);
  }

  const iosHandler = window.webkit?.messageHandlers?.lfAnalytics;
  if (iosHandler?.postMessage) {
    iosHandler.postMessage(payload);
  }

  if (window.LFNative?.postMessage) {
    window.LFNative.postMessage(json);
  }

  if (typeof window.Android?.onAnalyticsEvent === 'function') {
    window.Android.onAnalyticsEvent(json);
  }

  window.dispatchEvent(new CustomEvent('lf:analytics', { detail: payload }));

  if (typeof window.LFAnalytics?.onEvent === 'function') {
    window.LFAnalytics.onEvent(payload);
  }

  if (
    process.env.NODE_ENV === 'development' ||
    process.env.REACT_APP_ANALYTICS_DEBUG === 'true'
  ) {
    // eslint-disable-next-line no-console
    console.log('[LF Analytics]', payload.event, payload.params || {}, payload.user || {});
  }
}

/** Обновить user properties — попадают в каждое следующее событие. */
export function setAnalyticsUser(props = {}) {
  Object.assign(userProps, props);
}

/** Отправить событие в WebView / native shell. */
export function trackEvent(event, params = {}) {
  if (!event) return;
  sendToNative(buildPayload(event, params));
}

/**
 * Управление нативным chrome (нижнее меню WebView и т.п.).
 * payload: { type: 'ui', hide_bottom_nav, hide_chrome, screen }
 */
export function setNativeChrome({ hideBottomNav = false, hideChrome = false, screen = null } = {}) {
  if (typeof window === 'undefined') return;
  const payload = {
    type: 'ui',
    hide_bottom_nav: Boolean(hideBottomNav),
    hide_chrome: Boolean(hideChrome),
    screen: screen || undefined,
    timestamp: Date.now()
  };
  sendToNative(payload);
}

/** Инициализация моста при старте SPA. */
export function initWebViewBridge(bootstrap = {}) {
  if (typeof window === 'undefined') return;

  setAnalyticsUser(bootstrap);

  if (!window.LFAnalytics) {
    window.LFAnalytics = {
      track: trackEvent,
      setUserProperties: setAnalyticsUser,
      setNativeChrome,
      onEvent: null,
      Events
    };
  } else {
    window.LFAnalytics.setNativeChrome = setNativeChrome;
  }

  trackEvent(Events.APP_OPEN, bootstrap);
}

export { Events };
